export const REQUEST_FILTER_VALUES = ["all", "received", "sent", "suggested"] as const;
export type RequestFilter = (typeof REQUEST_FILTER_VALUES)[number];

export const DEFAULT_REQUEST_FILTER: RequestFilter = "all";

export const REQUEST_FILTER_OPTIONS: { value: RequestFilter; label: string }[] = [
  { value: "all", label: "ALL" },
  { value: "received", label: "Request Received" },
  { value: "sent", label: "Request Sent" },
  { value: "suggested", label: "Suggested Company" },
];

export const DASHBOARD_REQUESTS_TAB = "requests" as const;

/** Company sidebar Home. Legacy `/dashboard` redirects here. */
export const COMPANY_HOME_PATH = "/home";
export const COMPANY_HOME_LEGACY_PATH = "/dashboard";

/** Back navigation after viewing a suggested company in the collaboration workspace. */
export const SUGGESTED_COMPANIES_RETURN_TO = `${COMPANY_HOME_PATH}?tab=${DASHBOARD_REQUESTS_TAB}&filter=suggested`;

/** Home requests tab URL; back navigation from profile/workspace always uses ALL. */
export function buildDashboardReturnTo(filter: RequestFilter = DEFAULT_REQUEST_FILTER): string {
  return `${COMPANY_HOME_PATH}?tab=${DASHBOARD_REQUESTS_TAB}&filter=${filter}`;
}

export type DashboardInterestRowKind = "request" | "suggested";
export type DashboardInterestListSource = "received" | "sent" | "suggested" | "facilitator-suggested";

/** Dashboard back target when opening workspace/profile from the requests table. */
export function buildDashboardReturnToForInterestRow(
  _requestFilter: RequestFilter,
  _rowKind: DashboardInterestRowKind,
  _listSource?: DashboardInterestListSource,
): string {
  return buildDashboardReturnTo();
}

export function parseRequestFilter(raw: string | null): RequestFilter {
  if (raw === "facilitator-suggested" || raw === "facilitator") return "suggested";
  if (raw === "all" || raw === "received" || raw === "sent" || raw === "suggested") {
    return raw;
  }
  return DEFAULT_REQUEST_FILTER;
}

/**
 * Resolves request list filter from URL.
 * Supports `?filter=`, legacy `?tab=received|sent|incoming` and defaults to received.
 */
export function parseDashboardRequestFilter(
  tabParam: string | null,
  filterParam: string | null
): RequestFilter {
  if (filterParam) return parseRequestFilter(filterParam);
  if (tabParam === "sent") return "sent";
  if (tabParam === "received" || tabParam === "incoming") return "received";
  return DEFAULT_REQUEST_FILTER;
}

/** Legacy InterestsPage tab query (?tab=sent|incoming). */
export function parseLegacyRequestsTab(raw: string | null): RequestFilter {
  if (raw === "sent") return "sent";
  if (raw === "incoming") return "received";
  return DEFAULT_REQUEST_FILTER;
}
